/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontRefetch_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontLayout_viewer">;
    readonly " $refType": "StorefrontRefetch_viewer";
};
export type StorefrontRefetch_viewer$data = StorefrontRefetch_viewer;
export type StorefrontRefetch_viewer$key = {
    readonly " $data"?: StorefrontRefetch_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontRefetch_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontRefetch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontLayout_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '0af1ab8edca5d9d607f872d248fb31a4';
export default node;
